module.exports = __webpack_public_path__ + "linkedin-grey.png?5b480f6c1a1e84001e996d0aa606319d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/linkedin-grey.png
// module id = 970
// module chunks = 0